export var TripMemberStatus;
(function (TripMemberStatus) {
    TripMemberStatus["JOINED"] = "JOINED";
    TripMemberStatus["LEFT"] = "LEFT";
    TripMemberStatus["REQUESTED"] = "REQUESTED";
    TripMemberStatus["REQUEST_CANCELLED"] = "REQUEST_CANCELLED";
    TripMemberStatus["INVITED"] = "INVITED";
    TripMemberStatus["DECLINED"] = "DECLINED";
    TripMemberStatus["NOT_JOINED"] = "NOT_JOINED";
    TripMemberStatus["ANONYMOUS"] = "ANONYMOUS"; // User is not logged in or has not joined the trip
})(TripMemberStatus || (TripMemberStatus = {}));
